// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3yRq8","buttons":"Footer_buttons__2EBGa"};